import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import AddressBookList from './AddressBookList';
import AddEditReferralProviderPopup from '../Patient/Referral/AddEditReferralProviderPopup';
import AddEditReferralFacilityPopup from '../Patient/Referral/AddEditReferralFacilityPopup';
import AddEditReferralInsurancePopup from '../Patient/Referral/AddEditReferralInsurancePopup';
import { TbStethoscope } from 'react-icons/tb';
import { BiClinic } from 'react-icons/bi';
import { FaShieldHeart } from 'react-icons/fa6';
import { MdOutlineMoreHoriz } from 'react-icons/md';
import { useDebounce } from '../../Utilities/Utilities';
import { useSelector } from 'react-redux';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import setUiMessage from '../../Utilities/Tostify';

function AddressBookPopup({
  onClose,
  type = 2,
  selectAny = false,
  onSelectAddress,
  fromType = 'referral',
}) {
  const { user } = useSelector((store) => store.auth);
  const [addBookData, setAddBookData] = useState([]);
  const [typeState, setTypeState] = useState(type);
  const [srchVal, setSrchVal] = useState('');
  const debouncedSrchVal = useDebounce(srchVal, 500);

  const [reload, setReload] = useState(false);
  const onReload = () => setReload(!reload);
  const [editPopup, setEditPopup] = useState({
    open: false,
    referringMasterId: '',
  });

  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    id: '',
  });

  // const [distanceFilter, setDistanceFilter] = useState('all');

  // const distanceOptions = [
  //   { id: 'all', label: 'All' },
  //   { id: '10', label: 'Within 10 mi' },
  //   { id: '25', label: 'Within 25 mi' },
  //   { id: '50', label: 'Within 50 mi' },
  // ];

  useEffect(() => {
    const loadAddressBook = async () => {
      // Logic to load address book data
      const response = await post('api/CommonTask/openAddresspopup', {
        searchStr: '',
        type: typeState,
        selectAny,
      });

      if (response.status === 200) {
        setAddBookData(response.data || []);
      }
    };
    loadAddressBook();
  }, [typeState, selectAny, reload]);

  const handleAddressSelect = (address) => {
    if (selectAny || type === typeState) {
      onSelectAddress(address, typeState);
    }
  };

  const handleDeleteClick = (id) => {
    setDeleteDialog({
      open: true,
      id: id,
    });
  };

  const confirmDelete = async () => {
    try {
      const response = await post('api/CommonTask/deleteAddressBookRecord', {
        id: deleteDialog.id,
        type: typeState,
        userId: user?.id,
      });

      if (response.status === 200) {
        setUiMessage('suc', 'Successfully deleted the record.');
        onReload();
        setDeleteDialog({ open: false, id: '' });
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  const srch = debouncedSrchVal?.toLowerCase() || '';

  let masterData = [];

  if (typeState === 2) {
    masterData = addBookData?.referringMaster || [];
  } else if (typeState === 3 || typeState === 5) {
    masterData = addBookData?.facilityMaster || [];
  } else if (typeState === 4) {
    masterData = addBookData?.insuranceMaster || [];
  }

  const addressBookDataList = masterData.filter((item) => {
    // For type 2 (Referring Provider), ensure Name or Clinic is present as per requirements
    if (typeState === 2) {
      if (
        !item?.doctor_first_name &&
        !item?.doctor_last_name &&
        !item?.clinic_name
      ) {
        return false;
      }
    }

    const matchesSearch =
      String(item?.nameLabel || '')
        .toLowerCase()
        .includes(srch) ||
      String(item?.addressLabel || '')
        .toLowerCase()
        .includes(srch) ||
      String(item?.email || '')
        .toLowerCase()
        .includes(srch) ||
      String(item?.fax || '')
        .toLowerCase()
        .includes(srch) ||
      String(item?.phone_l || '')
        .toLowerCase()
        .includes(srch) ||
      String(item?.phone_m || '')
        .toLowerCase()
        .includes(srch) ||
      // Specific fields for different categories
      (typeState === 2 &&
        (String(item?.doctor_first_name || '')
          .toLowerCase()
          .includes(srch) ||
          String(item?.doctor_last_name || '')
            .toLowerCase()
            .includes(srch) ||
          String(item?.clinic_name || '')
            .toLowerCase()
            .includes(srch))) ||
      ((typeState === 3 || typeState === 5) &&
        String(item?.facility_name || '')
          .toLowerCase()
          .includes(srch)) ||
      (typeState === 4 &&
        String(item?.insurance_company_name || '')
          .toLowerCase()
          .includes(srch));

    return matchesSearch;
  });

  return (
    <div>
      <div className="modalBackground">
        <div className="openAddressBook openAddressBookModify">
          <div className="popup-header mb-0 flex justify-between items-center border-0">
            <h3 className="fw-600 fs-md text-accent-forground">
              Recipients Address Book
            </h3>
            <span
              className="close-btn close-btn fs-xl text-gray-400 mt-0"
              onClick={onClose}
            >
              &times;
            </span>
          </div>
          <div className="addressBody mt-3">
            <div className="flex items-center gap-2 mb-3">
              <div className="addressWrapper flex items-center border border-lightgray rounded-md flex-1 mb-0">
                <img
                  src="./images/search.svg"
                  width={15}
                  className="ml-2 opacity-60"
                  alt=""
                />
                <input
                  className="px-3 py-0 text-slate-600 addressInput flex-1 fs-13 form-control shadow-sm"
                  type="text"
                  id="addressBookSearh"
                  name="addressBookSearh"
                  placeholder="Search recipients..."
                  clickbutton="address-book-search"
                  onChange={(e) => setSrchVal(e.target.value)}
                />
                <span
                  className="button new-button cursor-style-for-link hide"
                  id="address-book-search"
                >
                  &nbsp;
                </span>
                <span
                  className="address-book-search-delete m-0 hide"
                  id="address-book-search-delete"
                  onClick={null}
                  clickbutton="address-book-search"
                >
                  X
                </span>
              </div>
              <button
                type="button"
                className="btn-outline-lightgray text-accent-forground rounded-md fs-13 flex-shrink-0 whitespace-nowrap"
                onClick={() =>
                  setEditPopup({ open: true, referringMasterId: '' })
                }
              >
                {typeState === 2 && '+ Add Provider'}
                {typeState === 3 && '+ Add Facility'}
                {typeState === 4 && '+ Add Insurance'}
                {typeState === 5 && '+ Add Recipient'}
              </button>
            </div>

            {/* <div className="flex items-center gap-2 mb-3 flex-wrap">
              <span className="fs-13 text-accent-forground">Distance:</span>
              {distanceOptions.map((option) => (
                <button
                  key={option.id}
                  type="button"
                  className={`btn-outline-lightgray text-accent-forground rounded-md fs-13 ${
                    distanceFilter === option.id ? 'addressSelection' : ''
                  }`}
                  onClick={() => setDistanceFilter(option.id)}
                >
                  {option.label}
                </button>
              ))}
            </div> */}

            <div className="addressBookTabsRow">
              <div
                className={`addressBookTabItem ${
                  typeState === 3 ? 'active' : ''
                }`}
                onClick={() => setTypeState(3)}
              >
                <BiClinic style={{ fontSize: '1.2rem' }} />
                Facilities
              </div>
              <div
                className={`addressBookTabItem ${
                  typeState === 2 ? 'active' : ''
                }`}
                onClick={() => setTypeState(2)}
              >
                <TbStethoscope style={{ fontSize: '1.2rem' }} />
                Referring Providers/Clinics
              </div>
              <div
                className={`addressBookTabItem ${
                  typeState === 4 ? 'active' : ''
                }`}
                onClick={() => setTypeState(4)}
              >
                <FaShieldHeart style={{ fontSize: '1.1rem' }} />
                Insurance
              </div>
              <div
                className={`addressBookTabItem ${
                  typeState === 5 ? 'active' : ''
                }`}
                onClick={() => setTypeState(5)}
              >
                <MdOutlineMoreHoriz style={{ fontSize: '1.2rem' }} />
                Others
              </div>
            </div>

            <div className="mb-3">
              {(() => {
                if (typeState === 2) {
                  return (
                    <AddressBookList
                      addressBookData={addressBookDataList}
                      type={typeState}
                      handleAddressSelect={handleAddressSelect}
                      editPopup={editPopup}
                      setEditPopup={setEditPopup}
                      onDelete={handleDeleteClick}
                    />
                  );
                } else if (typeState === 3 || typeState === 5) {
                  return (
                    <AddressBookList
                      addressBookData={addressBookDataList}
                      type={typeState}
                      selectAny={selectAny}
                      handleAddressSelect={handleAddressSelect}
                      editPopup={editPopup}
                      setEditPopup={setEditPopup}
                      onDelete={handleDeleteClick}
                    />
                  );
                } else if (typeState === 4) {
                  return (
                    <AddressBookList
                      addressBookData={addressBookDataList}
                      type={typeState}
                      selectAny={selectAny}
                      editPopup={editPopup}
                      handleAddressSelect={handleAddressSelect}
                      setEditPopup={setEditPopup}
                      onDelete={handleDeleteClick}
                    />
                  );
                }
              })()}
            </div>
            <div className="flex justify-end items-center pt-4 border-t border-t-lightgray gap-2">
              <button
                className="btn-outline-lightgray text-accent-forground rounded-md"
                onClick={onClose}
              >
                Cancel
              </button>
              <button className="btn-primary rounded-md">Done</button>
            </div>
          </div>
        </div>
        {typeState === 2 && editPopup.open && (
          <AddEditReferralProviderPopup
            onClose={() => setEditPopup({ open: false, referringMasterId: '' })}
            typeState={typeState}
            onReload={onReload}
            editPopup={editPopup}
            setEditPopup={setEditPopup}
          />
        )}
        {(typeState === 3 || typeState === 5) && editPopup.open && (
          <AddEditReferralFacilityPopup
            onClose={() => setEditPopup({ open: false, referringMasterId: '' })}
            typeState={typeState}
            onReload={onReload}
            editPopup={editPopup}
            setEditPopup={setEditPopup}
          />
        )}
        {typeState === 4 && editPopup.open && (
          <AddEditReferralInsurancePopup
            onClose={() => setEditPopup({ open: false, referringMasterId: '' })}
            typeState={typeState}
            onReload={onReload}
            editPopup={editPopup}
            setEditPopup={setEditPopup}
          />
        )}
        {deleteDialog.open && (
          <ConfirmDialog
            title={`Confirm!`}
            bodytext={`Do you really want to delete this record?`}
            closeDialog={() =>
              setDeleteDialog({
                open: false,
                id: '',
              })
            }
            successDialog={confirmDelete}
          />
        )}
      </div>
    </div>
  );
}

export default AddressBookPopup;
